import translate from '@translate';
import { useLocation, useNavigate } from 'react-router-dom';
import { TabType } from 'src/components/Tabs';
import { useCheckPermission } from 'src/utils/checkPermission';

export const getCommandsTopBlockParams = (): {
    tabs: TabType[];
    selected: string;
    handleChange: (newUrl: string) => void;
} => {
    const navigate = useNavigate();
    const location = useLocation();

    const handleChange = (newUrl: string) => {
        navigate('/commands/' + newUrl);
    };

    const selected = location.pathname.split('/')[2];

    const permissionProductCompletionSheets = useCheckPermission('PRODUCT_COMPLETION_SHEET.LIST');

    const tabs = [
        {
            value: 'product_completion_sheets',
            label: translate('commands.productCompletionSheets'),
            hidden: !permissionProductCompletionSheets,
        },
    ];

    return {
        tabs,
        selected,
        handleChange,
    };
};
